(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

var _kiVideo = require("./parts/kiVideo.js");
var _nav = require("./parts/nav.js");
var _accessibility = require("./parts/accessibility.js");
var _countdown = require("./parts/countdown.js");
var _speakerSlides = require("./parts/speaker-slides.js");
var _venue = require("./parts/venue.js");
document.addEventListener("DOMContentLoaded", function () {
  try {
    (0, _nav.nav)();
  } catch (error) {
    console.error("Error in nav():", error);
  }
  try {
    (0, _kiVideo.kiVideo)();
  } catch (error) {
    console.error("Error in kiVideo():", error);
  }
  try {
    (0, _accessibility.accessibility)();
  } catch (error) {
    console.error("Error in accessibility():", error);
  }
  try {
    (0, _countdown.countdown)();
  } catch (error) {
    console.error("Error in countdown():", error);
  }
  try {
    (0, _speakerSlides.speakerSlides)();
  } catch (error) {
    console.error("Error in speakerSlides():", error);
  }
  try {
    (0, _venue.initVenueToggles)();
  } catch (error) {
    console.error("Error in initVenueToggles():", error);
  }
});

},{"./parts/accessibility.js":2,"./parts/countdown.js":3,"./parts/kiVideo.js":4,"./parts/nav.js":5,"./parts/speaker-slides.js":6,"./parts/venue.js":7}],2:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.accessibility = accessibility;
function accessibility() {
  console.log("Accessibility initialized");
  // Skip link handler: focus the main content when skip link activated
  try {
    document.addEventListener('click', function (e) {
      var el = e.target;
      if (!el || !el.classList) return;
      if (el.classList.contains('skip-nav')) {
        // Prevent default jump; we'll manage focus for better behavior
        // allow normal anchor action too for browsers that handle it
        var href = el.getAttribute('href');
        var target = null;
        if (href && href.startsWith('#')) {
          var id = href.slice(1);
          target = document.getElementById(id);
        }
        if (!target) {
          // fallback to first <main>
          target = document.querySelector('main');
        }
        if (target) {
          // ensure target can receive focus
          if (!target.hasAttribute('tabindex')) {
            target.setAttribute('tabindex', '-1');
          }
          target.focus({
            preventScroll: true
          });
        }
      }
    }, false);
  } catch (err) {
    console.error('Accessibility skip-link handler failed', err);
  }
}
;

},{}],3:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.countdown = countdown;
function countdown() {
  var _timer$getAttribute, _timer$getAttribute2;
  console.log("Countdown initialized");
  var timer = document.getElementById('countdown-timer');
  if (!timer) return;
  var eventDateTimeStr = (_timer$getAttribute = timer.getAttribute('data-event-datetime')) === null || _timer$getAttribute === void 0 ? void 0 : _timer$getAttribute.trim();
  var eventEndDateTimeStr = (_timer$getAttribute2 = timer.getAttribute('data-event-end-datetime')) === null || _timer$getAttribute2 === void 0 ? void 0 : _timer$getAttribute2.trim();
  if (!eventDateTimeStr) return;
  var eventDate = new Date(eventDateTimeStr);
  if (isNaN(eventDate.getTime())) {
    timer.innerHTML = "<p>Invalid event date.</p>";
    return;
  }

  // Parse end datetime if provided
  var eventEndDate = null;
  if (eventEndDateTimeStr) {
    eventEndDate = new Date(eventEndDateTimeStr);
    if (isNaN(eventEndDate.getTime())) {
      eventEndDate = null;
    }
  }

  // Initial element references
  // const daysEl = timer.querySelector("#days");
  // const hoursEl = timer.querySelector("#hours");
  // const minutesEl = timer.querySelector("#minutes");
  // const secondsEl = timer.querySelector("#seconds");
  var d = timer.querySelector("#days");
  var h = timer.querySelector("#hours");
  var m = timer.querySelector("#minutes");
  var s = timer.querySelector("#seconds");

  // Visibility logic
  var dayWrapper = d === null || d === void 0 ? void 0 : d.parentElement;
  var hourWrapper = h === null || h === void 0 ? void 0 : h.parentElement;
  var minuteWrapper = m === null || m === void 0 ? void 0 : m.parentElement;
  var secondWrapper = s === null || s === void 0 ? void 0 : s.parentElement;

  // Padding helper
  var pad = function pad(n) {
    return String(n).padStart(2, '0');
  };
  var intervalId;
  function updateCountdown() {
    var now = new Date();

    // Check if event has ended
    if (eventEndDate && now >= eventEndDate) {
      timer.innerHTML = "<p>This event has ended!</p>";
      clearInterval(intervalId);
      return;
    }

    // Check if event has started
    var distance = eventDate - now;
    if (distance <= 0) {
      timer.innerHTML = "<p>This event has started!</p>";
      clearInterval(intervalId);
      return;
    }
    var days = Math.floor(distance / (1000 * 60 * 60 * 24));
    var hours = Math.floor(distance % (1000 * 60 * 60 * 24) / (1000 * 60 * 60));
    var minutes = Math.floor(distance % (1000 * 60 * 60) / (1000 * 60));
    var seconds = Math.floor(distance % (1000 * 60) / 1000);

    // Update values
    if (d) d.textContent = pad(days);
    if (h) h.textContent = pad(hours);
    if (m) m.textContent = pad(minutes);
    if (s) s.textContent = pad(seconds);
    if (days >= 7) {
      // > 7 days: show only days
      dayWrapper && (dayWrapper.style.display = 'flex');
      hourWrapper && (hourWrapper.style.display = 'none');
      minuteWrapper && (minuteWrapper.style.display = 'none');
      secondWrapper && (secondWrapper.style.display = 'none');
    } else if (days >= 3) {
      // 3–6 days: show day and hours
      dayWrapper && (dayWrapper.style.display = 'flex');
      hourWrapper && (hourWrapper.style.display = 'flex');
      minuteWrapper && (minuteWrapper.style.display = 'none');
      secondWrapper && (secondWrapper.style.display = 'none');
    } else if (days >= 1) {
      // 1–3 days: show hours and minutes blocks
      dayWrapper && (dayWrapper.style.display = 'flex');
      hourWrapper && (hourWrapper.style.display = 'flex');
      minuteWrapper && (minuteWrapper.style.display = 'flex');
      secondWrapper && (secondWrapper.style.display = 'none');
    } else {
      // Less than 24hr: hours, minutes and seconds
      if (dayWrapper) dayWrapper.style.display = 'none';
      if (hourWrapper) hourWrapper.style.display = 'flex';
      if (minuteWrapper) minuteWrapper.style.display = 'flex';
      if (secondWrapper) secondWrapper.style.display = 'flex';
    }
  }
  updateCountdown();
  intervalId = setInterval(updateCountdown, 1000);
}

},{}],4:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.kiVideo = kiVideo;
function kiVideo() {
  console.log("KI Video initialized");
}
;

},{}],5:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.nav = nav;
function nav() {
  console.log("NAV initialized");
  var OFFSET = 90; // Offset for scroll position
  var DURATION = 800;
  var scrollBtn = document.getElementById("scroll-direction-btn");
  var arrow = scrollBtn === null || scrollBtn === void 0 ? void 0 : scrollBtn.querySelector(".arrow");
  var sections = Array.from(document.querySelectorAll("main section, section"));
  var mainNav = document.getElementById("navbar-main");
  var stickyNav = document.getElementById("navbar-bottom");
  var toggleBtn = document.getElementById("mobile-menu-toggle");
  var closeBtn = document.getElementById("mobile-menu-close");
  var menu = document.getElementById("mobile-menu-wrapper");

  // Accessibility attributes: connect toggle -> menu and add label if missing
  if (toggleBtn && menu) toggleBtn.setAttribute('aria-controls', menu.id || 'mobile-menu-wrapper');
  if (menu && !menu.getAttribute('aria-label')) menu.setAttribute('aria-label', 'Mobile navigation');

  // Utility / pin behavior elements
  var utilEl = document.querySelector('.utility-bar-container, .utility-bar, #utility-bar');
  var currentSectionIndex = 0;

  // State for utility hide/pin behavior
  var utilHidden = false;
  var utilHeight = 0;
  var navHeight = mainNav ? mainNav.offsetHeight : 0;
  var latestY = 0;
  var ticking = false;

  // Focus management for mobile menu
  var lastFocusedBeforeMenu = null;
  var _trapKeydownHandler = null;

  // Smooth easing function
  function easeInOut(t) {
    return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
  }

  // Scroll to target element
  function smoothScrollTo(targetEl) {
    var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : OFFSET;
    var duration = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : DURATION;
    if (!targetEl) return;
    var startY = window.scrollY;
    var endY;

    // Ensure scroll to top respects the offset
    if (targetEl === document.body || targetEl === document.documentElement) {
      endY = 0; // Don't subtract offset here — already at top
    } else {
      endY = targetEl.getBoundingClientRect().top + startY - offset;
    }
    var distance = endY - startY;
    var startTime = performance.now();
    function scrollStep(timestamp) {
      var progress = Math.min((timestamp - startTime) / duration, 1);
      var ease = easeInOut(progress);
      window.scrollTo(0, startY + distance * ease);
      if (progress < 1) requestAnimationFrame(scrollStep);
    }
    requestAnimationFrame(scrollStep);
  }

  // Get index of current section in view
  function getCurrentSectionIndex() {
    var scrollMid = window.scrollY + window.innerHeight / 2;
    for (var i = 0; i < sections.length; i++) {
      var top = sections[i].offsetTop;
      var bottom = top + sections[i].offsetHeight;
      if (scrollMid >= top && scrollMid < bottom) return i;
    }
    return 0;
  }

  // --- Utility bar hide/show + pin main nav ---
  function updateHeights() {
    utilHeight = utilEl ? utilEl.offsetHeight : 0;
    navHeight = mainNav ? mainNav.offsetHeight : 0;

    // Expose header height to CSS so we can add top padding to <main>
    try {
      if (typeof document !== 'undefined' && document.documentElement) {
        document.documentElement.style.setProperty('--site-header-height', navHeight + 'px');
      }
    } catch (err) {
      // ignore in non-browser or test env
    }

    // If utility exists and is visible, place nav below it. Otherwise pin to top.
    if (mainNav) {
      if (!utilHidden && utilHeight > 0) {
        mainNav.style.top = utilHeight + 'px';
      } else {
        mainNav.style.top = '0px';
      }
      // reflect pinned state on body for CSS to read
      if (mainNav.classList.contains('pinned')) {
        document.body.classList.add('has-fixed-header');
      } else {
        document.body.classList.remove('has-fixed-header');
      }
    }
  }
  function handleScroll(y) {
    // when scrolled away from very top, hide utility and pin main nav
    if (!utilEl || utilHeight === 0) return;
    if (y > 0 && !utilHidden) {
      utilEl.classList.add('hidden');
      utilHidden = true;
      if (mainNav) {
        mainNav.classList.add('pinned');
        mainNav.style.top = '0px';
        // when pinned, ensure body class and CSS var are updated
        document.body.classList.add('has-fixed-header');
        try {
          document.documentElement.style.setProperty('--site-header-height', (mainNav.offsetHeight || navHeight) + 'px');
        } catch (e) {}
      }
      // no page padding applied; utility bar is fixed by external script
    } else if (y === 0 && utilHidden) {
      utilEl.classList.remove('hidden');
      utilHidden = false;
      if (mainNav) {
        mainNav.classList.remove('pinned');
        mainNav.style.top = utilHeight + 'px';
        // remove body class and update var
        document.body.classList.remove('has-fixed-header');
        try {
          document.documentElement.style.setProperty('--site-header-height', (mainNav.offsetHeight || navHeight) + 'px');
        } catch (e) {}
      }
      // no page padding applied; utility bar is fixed by external script
    }
  }
  function onScrollRaf() {
    latestY = window.scrollY || window.pageYOffset;
    if (!ticking) {
      ticking = true;
      requestAnimationFrame(function () {
        handleScroll(latestY);
        ticking = false;
      });
    }
  }

  // Initialize heights and listeners for utility behavior
  function initUtilityBehavior() {
    updateHeights();
    window.addEventListener('scroll', onScrollRaf, {
      passive: true
    });
    window.addEventListener('resize', function () {
      updateHeights();
    }, {
      passive: true
    });
    // ensure initial state on load
    window.addEventListener('load', function () {
      updateHeights();
      handleScroll(window.scrollY || 0);
    });
  }
  initUtilityBehavior();

  // Update scroll arrow direction
  function updateScrollButton() {
    if (menu !== null && menu !== void 0 && menu.classList.contains("open")) return; // skip when menu is open
    if (!scrollBtn || !arrow || sections.length < 2) return;
    currentSectionIndex = getCurrentSectionIndex();
    //const lastSection = sections[sections.length - 1];
    var bottomReached = window.scrollY + window.innerHeight >= document.body.offsetHeight - 50;
    scrollBtn.style.display = "flex";
    if (bottomReached) {
      arrow.classList.remove("down");
      arrow.classList.add("up");
    } else {
      arrow.classList.remove("up");
      arrow.classList.add("down");
    }
  }

  // Scroll arrow click behavior
  if (scrollBtn && arrow && sections.length > 0) {
    scrollBtn.addEventListener("click", function () {
      currentSectionIndex = getCurrentSectionIndex();
      if (arrow.classList.contains("down")) {
        var nextSection = sections[currentSectionIndex + 1];
        if (nextSection) {
          smoothScrollTo(nextSection);
        }
      } else {
        smoothScrollTo(document.body, 0);
      }
    });
    window.addEventListener("scroll", updateScrollButton);
    window.addEventListener("load", updateScrollButton);
  }

  // Nav links smooth scroll
  document.querySelectorAll('#navbar-main a[href^="#"]').forEach(function (link) {
    link.addEventListener("click", function (e) {
      e.preventDefault();
      var href = this.getAttribute("href");
      var targetId = href.substring(1);
      var targetEl;
      if (menu !== null && menu !== void 0 && menu.classList.contains("open")) {
        // Use closeMobileMenu() so focus is restored and ARIA states stay consistent
        try {
          closeMobileMenu();
        } catch (e) {
          // fallback: ensure menu is closed
          menu.classList.remove("open");
          document.body.classList.remove("no-scroll");
        }
        // toggleScrollButton may be defined elsewhere; guard the call
        try {
          if (typeof toggleScrollButton === 'function') toggleScrollButton(true);
        } catch (e) {}
        updateScrollButton();
      }
      if (href === "#" || targetId === "") {
        smoothScrollTo(document.body); // Will scroll to top
      } else {
        var _targetEl = document.getElementById(targetId);
        if (_targetEl) {
          smoothScrollTo(_targetEl); // Will subtract OFFSET = 90
        }
      }
      document.querySelectorAll("#navbar-main a").forEach(function (el) {
        return el.classList.remove("active");
      });
      this.classList.add("active");
    });
  });

  // Sticky bottom nav behavior
  if (stickyNav) {
    var updateSticky = function updateSticky(y) {
      var show = y > stickyThreshold;
      if (show) {
        stickyNav.classList.add('show');
      } else {
        stickyNav.classList.remove('show');
      }
    };
    var onStickyScroll = function onStickyScroll() {
      var y = window.scrollY || window.pageYOffset;
      if (!stickyTick) {
        stickyTick = true;
        requestAnimationFrame(function () {
          updateSticky(y);
          stickyTick = false;
        });
      }
    };
    stickyNav.style.transition = "transform 0.3s ease-in-out";
    // ensure initial hidden state by removing any 'show' class
    stickyNav.classList.remove('show');

    // Use rAF-throttled handler to show/hide sticky nav without
    // mutating page content padding (removing automated padding-bottom).
    var stickyTick = false;
    var stickyThreshold = 200;
    window.addEventListener('scroll', onStickyScroll, {
      passive: true
    });
    window.addEventListener('resize', function () {
      if (stickyNav) updateSticky(window.scrollY || 0);
    }, {
      passive: true
    });
    // initial state
    updateSticky(window.scrollY || 0);
  }

  // Mobile menu toggle
  function openMobileMenu() {
    if (!menu) return;

    // save last focused element to restore later
    try {
      lastFocusedBeforeMenu = document.activeElement;
    } catch (e) {
      lastFocusedBeforeMenu = null;
    }
    menu.classList.add('open');
    document.body.classList.add('no-scroll');
    if (toggleBtn) toggleBtn.setAttribute('aria-expanded', 'true');
    if (menu) menu.setAttribute('aria-hidden', 'false');

    // focus first focusable element in the menu (close button or first link)
    try {
      var focusable = Array.from(menu.querySelectorAll('a, button, input, textarea, select, [tabindex]:not([tabindex="-1"])')).filter(function (el) {
        return !el.hasAttribute('disabled') && el.offsetParent !== null;
      });
      var first = focusable.length ? focusable[0] : null;
      if (first && typeof first.focus === 'function') {
        first.focus();
      } else if (closeBtn && typeof closeBtn.focus === 'function') {
        closeBtn.focus();
      }
    } catch (e) {}

    // basic focus trap: keep Tab navigation inside the menu
    _trapKeydownHandler = function _trapKeydownHandler(e) {
      if (e.key !== 'Tab' || !menu.classList.contains('open')) return;
      var focusable = Array.from(menu.querySelectorAll('a, button, input, textarea, select, [tabindex]:not([tabindex="-1"])')).filter(function (el) {
        return !el.hasAttribute('disabled') && el.offsetParent !== null;
      });
      if (focusable.length === 0) {
        e.preventDefault();
        return;
      }
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (e.shiftKey) {
        if (document.activeElement === first) {
          e.preventDefault();
          last.focus();
        }
      } else {
        if (document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      }
    };
    document.addEventListener('keydown', _trapKeydownHandler);
  }
  function closeMobileMenu() {
    if (!menu) return;
    menu.classList.remove('open');
    document.body.classList.remove('no-scroll');
    if (toggleBtn) toggleBtn.setAttribute('aria-expanded', 'false');
    if (menu) menu.setAttribute('aria-hidden', 'true');

    // restore focus and remove focus trap
    try {
      if (lastFocusedBeforeMenu && typeof lastFocusedBeforeMenu.focus === 'function') lastFocusedBeforeMenu.focus();
    } catch (e) {}
    if (_trapKeydownHandler) {
      document.removeEventListener('keydown', _trapKeydownHandler);
      _trapKeydownHandler = null;
    }
  }
  if (toggleBtn) {
    toggleBtn.addEventListener('click', function (e) {
      e.preventDefault();
      if (menu !== null && menu !== void 0 && menu.classList.contains('open')) closeMobileMenu();else openMobileMenu();
      updateScrollButton();
    });
  }
  if (closeBtn) {
    closeBtn.addEventListener('click', function (e) {
      e.preventDefault();
      closeMobileMenu();
      updateScrollButton();
    });
  }

  // Close on ESC
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && menu !== null && menu !== void 0 && menu.classList.contains('open')) {
      closeMobileMenu();
    }
  });
}

},{}],6:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.speakerSlides = speakerSlides;
/* Active inline script extracted from `parts/speaker-slides.php`
     Now executed when `speakerSlides()` is called. */

function speakerSlides() {
  var scrollContainer = document.querySelector('.session-scroll-wrapper');
  if (!scrollContainer) return; // nothing to do

  var carousels = scrollContainer.querySelectorAll('.session-carousel');
  var dotsContainer = document.querySelector('.session-dots');
  var scrollInterval = 7000;
  var currentIndex = 0;
  var autoInterval = null;
  var resumeTimeout = null;
  var isPaused = false;
  // pointer tracking for tap vs drag
  var pointerState = new WeakMap();

  // Smooth manual scroll animation
  function animateScrollTo(targetLeft) {
    var duration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1200;
    var start = scrollContainer.scrollLeft;
    var change = targetLeft - start;
    var startTime = performance.now();
    function easeOutQuart(t) {
      return 1 - --t * t * t * t;
    }
    function animate(time) {
      var elapsed = time - startTime;
      var progress = Math.min(elapsed / duration, 1);
      var eased = easeOutQuart(progress);
      scrollContainer.scrollLeft = start + change * eased;
      if (progress < 1) requestAnimationFrame(animate);
    }
    requestAnimationFrame(animate);
  }

  // Scroll to a specific session
  function scrollToSession(index) {
    var target = carousels[index];
    if (!target) return;
    var targetLeft = target.offsetLeft;
    animateScrollTo(targetLeft);
    updateDots();
  }

  // Autoplay scrolling
  function autoScrollSessions() {
    stopAutoScroll();
    autoInterval = setInterval(function () {
      if (isPaused) return;
      currentIndex = (currentIndex + 1) % carousels.length;
      scrollToSession(currentIndex);
    }, scrollInterval);
  }
  function stopAutoScroll() {
    if (autoInterval) {
      clearInterval(autoInterval);
      autoInterval = null;
    }
  }
  function pauseAutoScrollTemporarily() {
    var ms = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 3000;
    isPaused = true;
    if (resumeTimeout) clearTimeout(resumeTimeout);
    resumeTimeout = setTimeout(function () {
      isPaused = false;
    }, ms);
  }

  // Manual navigation via arrows
  document.querySelectorAll('.session-nav.next').forEach(function (button) {
    button.addEventListener('click', function () {
      currentIndex = (currentIndex + 1) % carousels.length;
      scrollToSession(currentIndex);
    });
  });
  document.querySelectorAll('.session-nav.prev').forEach(function (button) {
    button.addEventListener('click', function () {
      currentIndex = (currentIndex - 1 + carousels.length) % carousels.length;
      scrollToSession(currentIndex);
    });
  });

  // Dots navigation
  carousels.forEach(function (_, i) {
    var dot = document.createElement('button');
    dot.classList.add('dot');
    if (i === 0) dot.classList.add('active');
    dot.setAttribute('aria-label', "Scroll to session ".concat(i + 1));
    dot.addEventListener('click', function () {
      currentIndex = i;
      scrollToSession(i);
    });
    if (dotsContainer) dotsContainer.appendChild(dot);
  });

  // Update active dot
  function updateDots() {
    if (!dotsContainer) return;
    var dots = dotsContainer.querySelectorAll('.dot');
    dots.forEach(function (dot) {
      return dot.classList.remove('active');
    });
    if (dots[currentIndex]) {
      dots[currentIndex].classList.add('active');
    }
  }

  // Start initial scroll
  setTimeout(function () {
    scrollToSession(0);
    autoScrollSessions();
  }, 1000);

  // Pause-on-touch / hover handlers
  // Pause when user interacts (pointerdown, touchstart, mouseenter) and resume after short delay
  scrollContainer.addEventListener('pointerdown', function (ev) {
    // record pointer start position to distinguish taps from drags
    pointerState.set(ev.target, {
      x: ev.clientX,
      y: ev.clientY,
      time: Date.now()
    });
    pauseAutoScrollTemporarily(4000);
  }, {
    passive: true
  });
  scrollContainer.addEventListener('pointerup', function (ev) {
    // decide whether this was a tap (small movement)
    var start = pointerState.get(ev.target);
    if (start) {
      var dx = Math.abs((ev.clientX || 0) - start.x);
      var dy = Math.abs((ev.clientY || 0) - start.y);
      var moved = Math.sqrt(dx * dx + dy * dy);
      // threshold for tap vs drag
      if (moved < 10) {
        // find nearest speaker-card ancestor
        var card = ev.target.closest('.speaker-card');
        if (card) {
          // ignore clicks on links inside details
          var hasLink = ev.target.closest('a');
          if (!hasLink) {
            // toggle overlay
            var isOpen = card.classList.toggle('is-open');
            var details = card.querySelector('.details');
            if (details) details.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
            // prevent further handling
            ev.preventDefault();
          }
        }
      }
    }
  }, {
    passive: false
  });
  scrollContainer.addEventListener('mouseenter', function () {
    isPaused = true;
  });
  scrollContainer.addEventListener('mouseleave', function () {
    isPaused = false;
  });

  // Close overlays when clicking/tapping outside or on Escape
  document.addEventListener('click', function (ev) {
    var open = document.querySelectorAll('.speaker-card.is-open');
    if (!open || open.length === 0) return;
    // if click is inside any open card, ignore
    for (var i = 0; i < open.length; i++) {
      var card = open[i];
      if (card.contains(ev.target)) return;
    }
    // otherwise close all
    for (var _i = 0; _i < open.length; _i++) {
      var _card = open[_i];
      _card.classList.remove('is-open');
      var details = _card.querySelector('.details');
      if (details) details.setAttribute('aria-hidden', 'true');
    }
  });
  document.addEventListener('keydown', function (ev) {
    if (ev.key === 'Escape' || ev.key === 'Esc') {
      document.querySelectorAll('.speaker-card.is-open').forEach(function (card) {
        card.classList.remove('is-open');
        var details = card.querySelector('.details');
        if (details) details.setAttribute('aria-hidden', 'true');
      });
    }
  });
}

},{}],7:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initVenueToggles = initVenueToggles;
// Scoped venue toggle behavior for #venue .venue-gallery
// Exports an initializer function to be called by your theme build entry.

function initVenueToggles() {
  var venue = document.getElementById('venue');
  if (!venue) return;
  var cards = venue.querySelectorAll('.venue-gallery');
  if (!cards.length) return;
  var isTouch = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
  cards.forEach(function (card) {
    var heading = card.querySelector('h3[role="button"]');
    var details = card.querySelector('.details');
    if (!heading || !details) return;

    // initialize ARIA
    heading.setAttribute('aria-expanded', 'false');
    details.setAttribute('aria-hidden', 'true');
    function setOpen(on) {
      card.classList.toggle('is-open', !!on);
      heading.setAttribute('aria-expanded', !!on ? 'true' : 'false');
      details.setAttribute('aria-hidden', !!on ? 'false' : 'true');
    }

    // Keyboard support: Enter/Space toggle, Escape close
    heading.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        setOpen(!card.classList.contains('is-open'));
      } else if (e.key === 'Escape') {
        setOpen(false);
      }
    });

    // Click/tap toggle
    heading.addEventListener('click', function (e) {
      e.preventDefault();
      setOpen(!card.classList.contains('is-open'));
    });

    // Close when tapping/clicking outside an open card (only when open)
    document.addEventListener('click', function (ev) {
      if (!card.classList.contains('is-open')) return;
      if (!card.contains(ev.target)) setOpen(false);
    }, {
      passive: true
    });
  });
}

// Auto-init when loaded directly in browser env (helps when not bundled)
if (typeof window !== 'undefined' && window.document) {
  document.addEventListener('DOMContentLoaded', function () {
    try {
      initVenueToggles();
    } catch (e) {/* swallow errors */}
  });
}

},{}]},{},[1]);
